import { GroupMember, SeasonTicket, DraftPick } from './draft';

export class GroupObject {
    group_id: string;
    team_id_fk: any;
    group_status: string;
    season_ticket_id: string;
    group_code: number;
    leader_uid: string;
    group_size: string;
    group_member_count: string;
    type: string;
    test: number;
    t_stamp: string;
    t_stamp_readable: string;
    group_members: Array<GroupMember> = [];
    season_ticket: SeasonTicket;
    group_draft_picks: Array<DraftPick> = [];
    invites: Array<any> = [];
    sched_tstamp: any;
    sched_tstamp_readable: any;
    tm_order_num_out: Number;
    max_preauth: Number;
    tstamp: any;

    constructor(groupOb) {
        this.group_id = groupOb.group_id;
        this.group_status = groupOb.group_status;
        this.season_ticket_id = groupOb.season_ticket_id_fk;
        this.group_code = groupOb.group_code;
        this.leader_uid = groupOb.leader_uid;
        this.group_size = groupOb.group_size;
        this.group_member_count = groupOb.group_member_count;
        this.type = groupOb.type;
        this.t_stamp = groupOb.tstamp;
        this.t_stamp_readable = groupOb.tstamp_readable;
        this.sched_tstamp = groupOb.sched_tstamp;
        this.sched_tstamp_readable = groupOb.sched_tstamp_readable;
        this.tm_order_num_out = groupOb.tm_order_num_out;

        // initialize group members and season ticket
        if (groupOb.group_members) {
            groupOb.group_members.forEach(jsonData => {
                const a = new GroupMember(jsonData);
                this.group_members.push(a);
            });
        }
        if (groupOb.group_draft_picks) {
            groupOb.group_draft_picks.forEach(jsonDraftPick => {
                const a = new DraftPick(jsonDraftPick);
                this.group_draft_picks.push(a);
            });
        }
        if (groupOb.season_ticket) {
            this.season_ticket = new SeasonTicket(groupOb.season_ticket);
        }
        if (groupOb.invites) {
            this.invites = groupOb.invites;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/group.ts